/**
 * Diccionario i18n del editor de Digi 12 (modules/games/digi12/digi12.js y su
 * pestaña en la vista de juegos). Clave = texto español EXACTO (estilo gettext).
 * Los literales globales (Guardar, Cancelar, Activo, Nombre, Global…) ya viven
 * en diccionario-comunes.js y NO se re-declaran acá.
 */

export const DICCIONARIO_DIGI12 = {
    'Semilla pendiente': { pt: 'Semente pendente', en: 'Seed pending', ru: 'Ожидается посев' },
    'Financiar y activar': { pt: 'Financiar e ativar', en: 'Fund and activate', ru: 'Профинансировать и активировать' },
    'No se pudo calcular la financiación': {
        pt: 'Não foi possível calcular o financiamento',
        en: 'Could not compute the funding',
        ru: 'Не удалось рассчитать финансирование',
    },
    'No se pudo financiar la colección': {
        pt: 'Não foi possível financiar a coleção',
        en: 'Could not fund the collection',
        ru: 'Не удалось профинансировать набор',
    },
    'Nuevo producto Digi 12': { pt: 'Novo produto Digi 12', en: 'New Digi 12 product', ru: 'Новый продукт Digi 12' },
    'Editar producto Digi 12': {
        pt: 'Editar produto Digi 12',
        en: 'Edit Digi 12 product',
        ru: 'Изменить продукт Digi 12',
    },
    'Producto Digi 12': { pt: 'Produto Digi 12', en: 'Digi 12 product', ru: 'Продукт Digi 12' },
    'Un producto nuevo se guarda pausado. Después de asignar y financiar sus cuatro pozos acumulados, podrás activarlo.':
        {
            pt: 'Um produto novo é salvo pausado. Depois de atribuir e financiar os quatro poços acumulados, você poderá ativá-lo.',
            en: 'A new product is saved paused. You can activate it after assigning and funding its four pooled pots.',
            ru: 'Новый продукт сохраняется на паузе. Его можно активировать после назначения и финансирования четырёх накопительных фондов.',
        },
    'Producto Digi 12 guardado': {
        pt: 'Produto Digi 12 salvo',
        en: 'Digi 12 product saved',
        ru: 'Продукт Digi 12 сохранён',
    },
    'Cargando productos...': { pt: 'Carregando produtos...', en: 'Loading products...', ru: 'Загрузка продуктов...' },
    'Error cargando productos': {
        pt: 'Erro ao carregar produtos',
        en: 'Error loading products',
        ru: 'Ошибка загрузки продуктов',
    },
    'Sin productos Digi 12 todavía': {
        pt: 'Ainda sem produtos Digi 12',
        en: 'No Digi 12 products yet',
        ru: 'Продуктов Digi 12 пока нет',
    },
    'No se pudo cargar el producto': {
        pt: 'Não foi possível carregar o produto',
        en: 'Could not load the product',
        ru: 'Не удалось загрузить продукт',
    },
    'No se pudo guardar el producto': {
        pt: 'Não foi possível salvar o produto',
        en: 'Could not save the product',
        ru: 'Не удалось сохранить продукт',
    },
    'Revisa el formulario:': { pt: 'Revise o formulário:', en: 'Check the form:', ru: 'Проверьте форму:' },
    'RTP de rueda:': { pt: 'RTP da roda:', en: 'Wheel RTP:', ru: 'RTP колеса:' },
    'RTP de rueda objetivo (%)': {
        pt: 'RTP da roda alvo (%)',
        en: 'Target wheel RTP (%)',
        ru: 'Целевой RTP колеса (%)',
    },
    'Sin pozos comunes. Rango permitido:': {
        pt: 'Sem jackpots comuns. Faixa permitida:',
        en: 'Without shared pots. Allowed range:',
        ru: 'Без общих фондов. Допустимый диапазон:',
    },
    'Forma de los tréboles': { pt: 'Forma dos trevos', en: 'Clover shape', ru: 'Форма клеверов' },
    'Frecuencia de tréboles': { pt: 'Frequência de trevos', en: 'Clover frequency', ru: 'Частота клеверов' },
    'Frecuencia equilibrada · volatilidad moderada': {
        pt: 'Frequência equilibrada · volatilidade moderada',
        en: 'Balanced frequency · moderate volatility',
        ru: 'Сбалансированная частота · умеренная волатильность',
    },
    'Premios agrupados · volatilidad alta': {
        pt: 'Prêmios agrupados · alta volatilidade',
        en: 'Clustered prizes · high volatility',
        ru: 'Сгруппированные призы · высокая волатильность',
    },
    'Método de resolución': {
        pt: 'Método de resolução',
        en: 'Resolution method',
        ru: 'Метод определения результата',
    },
    'Control de volatilidad y retorno': {
        pt: 'Controle de volatilidade e retorno',
        en: 'Volatility and return control',
        ru: 'Контроль волатильности и возврата',
    },
    'Aleatorio puro · premios ponderados por perfil': {
        pt: 'Aleatório puro · prêmios ponderados pelo perfil',
        en: 'Pure random · prizes weighted by profile',
        ru: 'Чистый случайный выбор · призы взвешены по профилю',
    },
    'Control de volatilidad ajusta el resultado al retorno configurado. Aleatorio puro da la misma probabilidad a cada número y pondera los premios con el perfil de tréboles. La elección se congela con cada jugada.':
        {
            pt: 'O controle de volatilidade ajusta o resultado ao retorno configurado. O aleatório puro dá a mesma probabilidade a cada número e pondera os prêmios pelo perfil de trevos. A escolha fica congelada em cada jogada.',
            en: 'Volatility control adjusts the result to the configured return. Pure random gives every number the same probability and weights prizes with the clover profile. The choice is frozen for each play.',
            ru: 'Контроль волатильности корректирует результат под заданную отдачу. Чистый случайный режим даёт каждому числу одинаковую вероятность и взвешивает призы по профилю клеверов. Выбор фиксируется для каждой игры.',
        },
    'Valores de ficha (centavos)': {
        pt: 'Valores de ficha (centavos)',
        en: 'Chip values (cents)',
        ru: 'Номиналы фишек (центы)',
    },
    'Cinco importes enteros positivos, de menor a mayor, sin repetir. Ej.: [20, 50, 100, 250, 500]. El jugador elige uno; cambiarlo no altera apuestas ya armadas.':
        {
            pt: 'Cinco valores inteiros positivos, do menor ao maior, sem repetir. Ex.: [20, 50, 100, 250, 500]. O jogador escolhe um; trocá-lo não altera apostas já montadas.',
            en: 'Five positive whole amounts, smallest to largest, no repeats. E.g.: [20, 50, 100, 250, 500]. The player picks one; changing it does not alter existing bets.',
            ru: 'Пять целых положительных сумм по возрастанию, без повторов. Напр.: [20, 50, 100, 250, 500]. Игрок выбирает одну; смена не меняет уже собранные ставки.',
        },
    'Ficha inicial (centavos)': {
        pt: 'Ficha inicial (centavos)',
        en: 'Initial chip (cents)',
        ru: 'Начальная фишка (центы)',
    },
    'La ficha activa al abrir el juego. Debe ser uno de los valores de ficha.': {
        pt: 'A ficha ativa ao abrir o jogo. Deve ser um dos valores de ficha.',
        en: 'The chip selected when the game opens. It must be one of the chip values.',
        ru: 'Фишка, выбранная при открытии игры. Должна быть одним из номиналов.',
    },
    'Multiplicador del pleno': {
        pt: 'Multiplicador do pleno',
        en: 'Straight-up multiplier',
        ru: 'Множитель прямой ставки',
    },
    'Tope por apuesta (centavos)': {
        pt: 'Teto por aposta (centavos)',
        en: 'Cap per bet (cents)',
        ru: 'Лимит на ставку (центы)',
    },
    '0 = sin tope': { pt: '0 = sem teto', en: '0 = no cap', ru: '0 = без лимита' },
    'Pozos comunes (uno por nivel)': {
        pt: 'Poços acumulados (um por nível)',
        en: 'Shared pots (one per level)',
        ru: 'Общие фонды (по одному на уровень)',
    },
    'Digi 12 no juega sin los cuatro. Solo pozos con acarreo y no compartidos con otro juego.': {
        pt: 'Digi 12 não joga sem os quatro. Só poços com acúmulo fracionário e não compartilhados com outro jogo.',
        en: 'Digi 12 does not play without all four. Only pots with carry-over and not shared with another game.',
        ru: 'Digi 12 не играет без всех четырёх. Только фонды с переносом и не общие с другой игрой.',
    },
    'Colección financiada': { pt: 'Coleção financiada', en: 'Funded collection', ru: 'Профинансированная коллекция' },
    'Colección de pozos incompleta': {
        pt: 'Coleção de poços incompleta',
        en: 'Pot collection incomplete',
        ru: 'Набор фондов неполный',
    },
    'Colección de pozos acumulados incompleta': {
        pt: 'Coleção de poços acumulados incompleta',
        en: 'Accumulated-pot collection incomplete',
        ru: 'Коллекция накопительных фондов неполна',
    },
    '— sin asignar —': { pt: '— sem atribuir —', en: '— unassigned —', ru: '— не назначен —' },
    'Giro de la rueda': { pt: 'Giro da roda', en: 'Wheel spin', ru: 'Вращение колеса' },
    'Solo presentación: no cambia resultado, RTP ni pozos. Sin editar, gira como hoy.': {
        pt: 'Só apresentação: não muda resultado, RTP nem poços. Sem editar, gira como hoje.',
        en: 'Presentation only: it does not change outcome, RTP or pots. Left untouched, it spins as today.',
        ru: 'Только презентация: не меняет результат, RTP и фонды. Без правок вращается как сейчас.',
    },
    'Duración (ms)': { pt: 'Duração (ms)', en: 'Duration (ms)', ru: 'Длительность (мс)' },
    'Velocidad de crucero (RPM)': {
        pt: 'Velocidade de cruzeiro (RPM)',
        en: 'Cruise speed (RPM)',
        ru: 'Крейсерская скорость (об/мин)',
    },
    'Tensión final': { pt: 'Tensão final', en: 'Final tension', ru: 'Финальное напряжение' },
    General: { pt: 'Geral', en: 'General', ru: 'Общее' },
    'Identidad y apuesta': { pt: 'Identidade e aposta', en: 'Identity and bet', ru: 'Идентичность и ставка' },
    Economía: { pt: 'Economia', en: 'Economy', ru: 'Экономика' },
    'Frecuencia, retorno y resolución': {
        pt: 'Frequência, retorno e resolução',
        en: 'Frequency, return and resolution',
        ru: 'Частота, возврат и результат',
    },
    'Pozos acumulados': { pt: 'Poços acumulados', en: 'Accumulated pots', ru: 'Накопительные фонды' },
    'Una colección de cuatro niveles': {
        pt: 'Uma coleção de quatro níveis',
        en: 'A four-level collection',
        ru: 'Коллекция из четырёх уровней',
    },
    Presentación: { pt: 'Apresentação', en: 'Presentation', ru: 'Представление' },
    'Ritmo visual de la rueda': { pt: 'Ritmo visual da roda', en: 'Visual wheel rhythm', ru: 'Визуальный ритм колеса' },
    'El grupo completa Grand, Major, Minor y Mini de una vez. Puedes ajustar cada nivel después.': {
        pt: 'O grupo preenche Grand, Major, Minor e Mini de uma vez. Você pode ajustar cada nível depois.',
        en: 'The group fills Grand, Major, Minor and Mini at once. You can adjust each level afterwards.',
        ru: 'Группа заполняет Grand, Major, Minor и Mini сразу. Затем каждый уровень можно изменить.',
    },
    'Estos valores cambian la animación, nunca el resultado ni el premio.': {
        pt: 'Estes valores alteram a animação, nunca o resultado nem o prêmio.',
        en: 'These values change the animation, never the result or prize.',
        ru: 'Эти значения меняют анимацию, но не результат и не приз.',
    },
    'Completa la economía para ver su frecuencia.': {
        pt: 'Complete a economia para ver a frequência.',
        en: 'Complete the economy to see its frequency.',
        ru: 'Заполните экономические параметры, чтобы увидеть частоту.',
    },
    'Frecuencia equilibrada': {
        pt: 'Frequência equilibrada',
        en: 'Balanced frequency',
        ru: 'Сбалансированная частота',
    },
    'Premios agrupados': { pt: 'Prêmios agrupados', en: 'Clustered prizes', ru: 'Сгруппированные призы' },
    'Volatilidad moderada': { pt: 'Volatilidade moderada', en: 'Moderate volatility', ru: 'Умеренная волатильность' },
    'Volatilidad alta': { pt: 'Volatilidade alta', en: 'High volatility', ru: 'Высокая волатильность' },
    'Más rondas con un trébol y una cola de premios progresiva.': {
        pt: 'Mais rodadas com um trevo e uma cauda progressiva de prêmios.',
        en: 'More rounds with one clover and a progressive prize tail.',
        ru: 'Больше раундов с одним клевером и постепенно растущим хвостом призов.',
    },
    'Más rondas sin trébol; cuando aparecen, es más frecuente que lleguen varios.': {
        pt: 'Mais rodadas sem trevo; quando aparecem, é mais comum virem vários.',
        en: 'More rounds without a clover; when they appear, several are more likely.',
        ru: 'Больше раундов без клевера; при появлении чаще выпадает несколько.',
    },
    trébol: { pt: 'trevo', en: 'clover', ru: 'клевер' },
    tréboles: { pt: 'trevos', en: 'clovers', ru: 'клеверов' },
    'aprox. 1 cada': { pt: 'aprox. 1 a cada', en: 'approx. 1 every', ru: 'примерно 1 из' },
    'RTP de rueda calculado': { pt: 'RTP calculado da roda', en: 'Calculated wheel RTP', ru: 'Расчётный RTP колеса' },
    'media de tréboles': { pt: 'média de trevos', en: 'average clovers', ru: 'среднее число клеверов' },
    'Solo se activa con los cuatro pozos comunes válidos; lo comprueba el servidor.': {
        pt: 'Só se ativa com os quatro poços acumulados válidos; o servidor confere.',
        en: 'It only activates with the four valid shared pots; the server checks it.',
        ru: 'Активируется только с четырьмя валидными общими фондами; проверяет сервер.',
    },

    // Grupo de pozos — selector que fija los cuatro niveles de una vez.
    // «Personalizado», «Global» y «más» ya viven en los diccionarios comunes.
    Grupo: { pt: 'Grupo', en: 'Group', ru: 'Группа' },
    '— sin grupo —': { pt: '— sem grupo —', en: '— no group —', ru: '— без группы —' },
    'en uso por': { pt: 'em uso por', en: 'in use by', ru: 'используется' },
    y: { pt: 'e', en: 'and', ru: 'и' },
    // ── Puente con el alta de pozos acumulados ───────────────────────────────
    'Crear grupo de cuatro pozos acumulados': {
        pt: 'Criar grupo de quatro poços acumulados',
        en: 'Create a group of four accumulated pots',
        ru: 'Создать группу из четырёх накопительных фондов',
    },
    'Abre el alta de pozos acumulados y, al terminar, deja los cuatro niveles seleccionados aquí. No los financia ni activa el producto.':
        {
            pt: 'Abre o cadastro de poços acumulados e, ao terminar, deixa os quatro níveis selecionados aqui. Não os financia nem ativa o produto.',
            en: 'Opens the accumulated pots form and, when done, leaves the four levels selected here. It does not fund them or activate the product.',
            ru: 'Открывает создание накопительных фондов и по завершении оставляет четыре уровня выбранными здесь. Не финансирует их и не активирует продукт.',
        },
    'creado y seleccionado': {
        pt: 'criado e selecionado',
        en: 'created and selected',
        ru: 'создана и выбрана',
    },
    'El grupo se creó, pero no se pudo recargar la lista. Volver a abrir el producto.': {
        pt: 'O grupo foi criado, mas não foi possível recarregar a lista. Abra o produto novamente.',
        en: 'The group was created, but the list could not be reloaded. Open the product again.',
        ru: 'Группа создана, но список не удалось обновить. Откройте продукт заново.',
    },
};
